import { asyncStatusContainerFactory } from 'affiny-core/modules/asynchronousState/containers/asyncStatusContainerFactory';
import { AsyncStatusHandler } from './AsyncStatusHandler.component';

export const AsyncStatusHandlerContainer = asyncStatusContainerFactory(
  AsyncStatusHandler
);
